import { SVGProps } from 'react'

export const Brain = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3828 2.18586L15.0854 2L14.7528 2.1109L11.9273 3.05272L9.10184 2.1109L8.76916 2L8.47179 2.18586L4.39056 4.73662L4.04062 4.95533V5.368V7.5465L2.29782 8.8536L2 9.07696V9.44924V13.5305V13.9028L2.29783 14.1261L4.04062 15.4332V18.632V19.0447L4.39056 19.2634L8.47179 21.8141L8.76917 22L9.10185 21.8891L11.9273 20.9473L14.7527 21.8891L15.0854 22L15.3828 21.8141L19.464 19.2634L19.814 19.0447V18.632V15.4332L21.5568 14.1261L21.8546 13.9028V13.5305V9.44924V9.07696L21.5568 8.85359L19.814 7.54649V5.368V4.95533L19.464 4.73662L15.3828 2.18586ZM5.52972 5.78066L8.96363 3.63447L11.1828 4.37418V8.02907V8.33748L11.4008 8.55555L13.2688 10.4235C13.2037 10.6059 13.1682 10.8025 13.1682 11.0073C13.1682 11.9667 13.946 12.7445 14.9055 12.7445C15.865 12.7445 16.6428 11.9667 16.6428 11.0073C16.6428 10.0478 15.865 9.26999 14.9055 9.26999C14.7007 9.26999 14.5042 9.30543 14.3217 9.37052L12.6719 7.72067V4.37418L14.891 3.63447L18.3249 5.78066V7.91877V8.29105L18.6227 8.51442L20.3655 9.82152V13.1582L18.6227 14.4652L18.3249 14.6886V15.0609V18.2194L14.891 20.3655L12.6719 19.6258V15.9709V15.6625L12.4538 15.4445L10.5859 13.5765C10.651 13.3941 10.6864 13.1975 10.6864 12.9927C10.6864 12.0333 9.90859 11.2555 8.94912 11.2555C7.98965 11.2555 7.21184 12.0333 7.21184 12.9927C7.21184 13.9522 7.98965 14.73 8.94912 14.73C9.15393 14.73 9.35046 14.6946 9.53292 14.6295L11.1828 16.2793V19.6258L8.96362 20.3655L5.52972 18.2194V15.0609V14.6886L5.23188 14.4652L3.4891 13.1582V9.82151L5.2319 8.51441L5.52972 8.29105V7.91877V5.78066Z"
      fill="currentColor"
    />
  </svg>
)
